export const storePoiList = (state, poiList) => {
  state.poiList = [...poiList];
};
